/**
 * 매칭 유형 표기 통일 ($j.F.Admin.MatchTag).
 *
 * 같은 정보(배정 알고리즘 NC/NS + 세대 ver)를 화면마다 다르게 그리고 있었다 —
 * 배분분포는 "NC ver4", 매칭리스트 유형줄은 한글명만, 통계 모달은 색만 칠한 빈 네모.
 * 표기가 갈리면 같은 오더를 보고도 어느 세대로 매칭됐는지 맞춰볼 수가 없다.
 * 세 화면이 여기 한 곳에서만 표기를 만들어 쓴다.
 *
 *   badge(dt, ver)  "NC ver4" 뱃지 — 표·정보줄용
 *   code(dt, ver)   "C4" 두 글자 — 칸(셀)용. 색만으로 구분하면 색약에서 NC/NS 가 안 갈린다.
 *   text(dt, ver)   "NC ver4" 순수 텍스트 — title 속성용
 *   cls(dt)         is-nc / is-ns / is-none — 색 클래스 (스타일은 components/_match-tag.scss)
 *
 * ver 은 g5_orders.match_info 에서 decode 된 값(MatchInfo). 0/빈값이면 세대 표기를 생략한다.
 */
export default class MatchTag {
    /** NS2·NE 는 NS 계열(미수주자용) — 색은 하나로 묶는다 */
    static cls(dt) {
        if (dt === 'NC') return 'is-nc';
        if (dt === 'NS' || dt === 'NS2' || dt === 'NE') return 'is-ns';
        return 'is-none';
    }

    static text(dt, ver) {
        const v = parseInt(ver, 10) || 0;
        return (dt || '-') + (v > 0 ? ` ver${v}` : '');
    }

    static code(dt, ver) {
        const v = parseInt(ver, 10) || 0;
        const c = dt === 'NC' ? 'C' : (this.cls(dt) === 'is-ns' ? 'S' : '?');
        return c + (v > 0 ? v : '');
    }

    static badge(dt, ver) {
        const v = parseInt(ver, 10) || 0;
        return `<span class="mtag ${this.cls(dt)}"><b>${this._esc(dt || '-')}</b>`
             + (v > 0 ? `<i>ver${v}</i>` : '') + '</span>';
    }

    static _esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }
}
